"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var numeral_1 = __importDefault(require("numeral"));
var functions_1 = require("../functions");
var VolumeAtendimentoUtil = /** @class */ (function () {
    function VolumeAtendimentoUtil() {
    }
    VolumeAtendimentoUtil.isVolumeAtendimentoValid = function (consumoMedio, volume, atendimento) {
        var step = consumoMedio * 0.01;
        var maxStep = step * 1.5;
        var minStep = step * 0.5;
        var calculatedStep = ((volume * 100) / atendimento) * 0.01;
        return (calculatedStep >= minStep && calculatedStep <= maxStep && atendimento >= 1 && atendimento <= 100 && volume >= 0.01);
    };
    VolumeAtendimentoUtil.MWhToMWmed = function (mwmed, mesReferencia) {
        var hoursInMonth = functions_1.Calendar.hoursInMonth(mesReferencia.month, mesReferencia.year);
        return numeral_1.default(mwmed)
            .divide(hoursInMonth)
            .value();
    };
    VolumeAtendimentoUtil.MWmedToMWh = function (mwmed, mesReferencia) {
        var hoursInMonth = functions_1.Calendar.hoursInMonth(mesReferencia.month, mesReferencia.year);
        return numeral_1.default(mwmed)
            .multiply(hoursInMonth)
            .value();
    };
    return VolumeAtendimentoUtil;
}());
exports.default = VolumeAtendimentoUtil;
